import { render, staticRenderFns } from "./UpdateCategory.vue?vue&type=template&id=35ee6413&scoped=true"
import script from "./UpdateCategory.vue?vue&type=script&lang=js"
export * from "./UpdateCategory.vue?vue&type=script&lang=js"
import style0 from "./UpdateCategory.vue?vue&type=style&index=0&id=35ee6413&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ee6413",
  null
  
)

export default component.exports